(() => {
  const bindMenu = (root) => {
    const parents = root.querySelectorAll?.('.st-nav-parent--desktop') || [];
    parents.forEach(parent => {
      if (parent.dataset.hoverMenu) return;
      const details = parent.querySelector(':scope > header-menu > details, :scope > details');
      if (!details) return;
      parent.dataset.hoverMenu = 'ready';
      const summary = details.querySelector('summary');
      let timer;
      let hoverOpened = false;
      const setOpen = (open) => { details.open = open; summary?.setAttribute('aria-expanded', String(open)); };
      parent.addEventListener('pointerenter', () => { if (!matchMedia('(hover:hover) and (pointer:fine)').matches) return; clearTimeout(timer); hoverOpened = !details.open; setOpen(true); });
      parent.addEventListener('pointerleave', () => { if (!matchMedia('(hover:hover) and (pointer:fine)').matches) return; timer = setTimeout(() => setOpen(false), 180); });
      summary.addEventListener('click', event => {
        if (event.detail > 0 && hoverOpened && details.open) {
          event.preventDefault();
          setOpen(true);
        }
        hoverOpened = false;
      });
      details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
      parent.addEventListener('focusin' , event => { if (event.target === summary) return; clearTimeout(timer); setOpen(true); });
      parent.addEventListener('focusout', event => { if (!parent.contains(event.relatedTarget)) { clearTimeout(timer); setOpen(false); } });
      parent.addEventListener('keydown', event => { if (event.key === 'Escape') { clearTimeout(timer); setOpen(false); summary?.focus(); event.preventDefault(); } });
    });
  };
  const update = (root) => {
    bindMenu(root);
    const links = root.matches?.('a[href]') ? [root] : root.querySelectorAll?.('a[href]') || [];
    links.forEach(link => {
      let url; try { url = new URL(link.getAttribute('href'), location.origin); } catch { return; }
      if (url.origin !== location.origin) return;
      const isDeletedLarge = url.pathname.endsWith('/collections/large-space-scent-diffusers');
      const isClosedComparison = url.pathname.endsWith('/pages/compare-diffusers');
      const isLegacyDevices = url.pathname.endsWith('/collections/all') && url.searchParams.get('view') === 'diffusers';
      const isNamedDeviceLink = url.pathname.endsWith('/collections/all') && !url.searchParams.has('view') && ['explore all scent diffusers', 'explore diffusers', 'find your diffuser', 'compare systems first', 'all systems'].includes(link.textContent.trim().toLowerCase());
      if (!isClosedComparison && !isLegacyDevices && !isNamedDeviceLink && !isDeletedLarge) return;
      const suffix = isDeletedLarge ? '/collections/large-space-scent-diffusers' : isClosedComparison ? '/pages/compare-diffusers' : '/collections/all';
      const prefix = url.pathname.slice(0, -suffix.length);
      if (isClosedComparison) { url.search = ''; url.hash = ''; } else { url.searchParams.delete('view'); }
      link.href = prefix + (isDeletedLarge ? '/collections/commercial-scent-diffusers' : '/collections/scent-diffusers') + url.search + url.hash;
      if (!isClosedComparison) return;
      if (!link.querySelector('img')) link.textContent = document.documentElement.lang.startsWith('zh') ? '选购香氛设备' : 'Explore diffusers';
    });
  };
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.st-nav-parent--desktop details[open]').forEach(details => {
      const summary = details.querySelector(':scope > summary');
      const hadFocus = details.contains(document.activeElement);
      details.open = false;
      summary?.setAttribute('aria-expanded', 'false');
      if (hadFocus) summary?.focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.st-nav-parent--desktop').forEach(parent => {
      if (parent.contains(event.target)) return;
      const details = parent.querySelector(':scope > header-menu > details, :scope > details');
      if (details) details.open = false;
    });
  });
  update(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) update(node); }))).observe(document.body, {childList:true,subtree:true});
})();


